export default __webpack_public_path__ + "static/media/twitter.162fbff3.svg";